<template>
  <div class='waf-issue-body'>
    <div class="description-block">
      <div class="data-title">{{$t('detailed.issue.description.title')}}</div>
      <div class="text-container">
        {{description}}
      </div>
    </div>
    <div class="asset-block">
      <div class="data-title">{{$t('detailed.issue.asset.title')}}</div>
      <div class="text-container">
        {{asset}}
      </div>
    </div>
    <div class="tld-block">
      <div class="data-title">{{$t('detailed.issue.tld.title')}}</div>
      <div class="text-container">
        {{tld}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WafIssueBody',
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tld() {
      return this.issue.tld;
    },
    asset() {
      return this.issue.asset;
    },
    metaData() {
      return this.issue.metaData;
    },
    description() {
      return this.issue.description;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.waf-issue-body {
  .details-column {
    display: inline-block;
    width: fit-content;
    max-width: rem(650);
    margin-right: $space-4;
  }
  .description-block {
    display: block;
    width: rem(650);
    .text-container::first-letter {
      text-transform: capitalize;
    }
    .text-container {
      padding-right: $space-15;
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      padding-bottom: $space-5;
    }
  }
  .data-sub-title {
    font-size: $font-size-xs;
    color: var(--text-secondary);
    letter-spacing: 0.8px;
    line-height: rem(10);
    text-transform: uppercase;
    margin-bottom: $space-1;
  }
  .data-title {
    color: var(--text-secondary);
    font-size: $font-size-sm;
    letter-spacing: 0.8px;
    line-height: rem(10);
    text-transform: uppercase;
    margin-bottom: $space-1;
  }
  .asset-block {
    margin-bottom: $space-5;
  }
  .tld-block {
    margin-bottom: $space-5;
  }
}
</style>
